import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    button: {
        display: "flex",
        height: rem(40),
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        alignItems: "center",
        alignSelf: "stretch",
        width: "100%",
        borderRadius: rem(4),
        border: `1px solid ${theme.colors.gray[3]}`,
        background: theme.colors.surfaceWhite,
        justifyContent: "space-between",
        "& .mantine-UnstyledButton-root": {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
        },
        "& .mantine-Button-inner": {
            gap: theme.spacing.md,
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
        },
        "& .mantine-Button-label": {
            color: theme.colors.gray[7],
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "14px",
        },
        "& .mantine-Button-rightIcon": {
            marginLeft: "auto",
        },
    },
}))
